import { Component, ModuleWithProviders, NgModule } from '@angular/core';
import {
    DefaultUrlSerializer,
    provideRoutes,
    RouterModule,
    Routes,
    UrlSerializer,
    UrlTree,
} from '@angular/router';

import { AuthService } from './auth/auth.service';

export class CmpsUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        url = url || '';
        const queryIndex = url.indexOf('?');
        const fragmentIndex = url.indexOf('#');
        const index = queryIndex !== -1 ? queryIndex : fragmentIndex;
        return super.parse(
            index === -1
                ? url.toLowerCase()
                : url.substring(0, index).toLowerCase() + url.substring(index),
        );
    }
}

@Component({ selector: 'http-404', template: '404' })
export class Http404 {}

@NgModule({
    imports: [RouterModule.forChild([])],
    exports: [RouterModule],
})
export class CmpsLazyRouterModule {
    static forChild(routes: Routes): ModuleWithProviders<CmpsLazyRouterModule> {
        return {
            ngModule: CmpsLazyRouterModule,
            providers: [
                provideRoutes(routes),
                { provide: UrlSerializer, useClass: CmpsUrlSerializer },
            ],
        };
    }
}

@NgModule({
    imports: [
        RouterModule.forRoot([], {
            useHash: CMPS_APP_DEF.USE_HASH,
            initialNavigation: 'disabled',
            relativeLinkResolution: 'legacy',
            scrollPositionRestoration: 'enabled',
        }),
    ],
    declarations: [Http404],
    exports: [RouterModule],
})
export class CmpsRouterModule {
    static forRoot(): ModuleWithProviders<CmpsRouterModule> {
        return {
            ngModule: CmpsRouterModule,
            providers: [
                // these will and must be appended last
                provideRoutes([
                    { path: '', pathMatch: 'full', redirectTo: 'login' },
                    { path: '404', pathMatch: 'full', component: Http404 },
                    {
                        path: '**',
                        component: Http404,
                        canActivate: [AuthService],
                    },
                ]),
                { provide: UrlSerializer, useClass: CmpsUrlSerializer },
            ],
        };
    }
}
